import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions, Response, ResponseContentType } from '@angular//http';
import { User } from '../_models/index';
import 'rxjs/add/operator/toPromise';
import { AuthHttp } from 'angular2-jwt';
import { environment } from '../../environments/environment';

@Injectable()

export class GenerateCouponServices {

    backendUrl: any;
    TOKEN: any;
    headers: any;
    options: any;
    secret: any;

    api = "/generatecp/"

    constructor(private http: AuthHttp) {
        // this.backendUrl = environment.url;
        this.backendUrl=window.location.origin
        this.backendUrl+="/apis"
        this.secret = environment.secret;
    }

     getallCouponCodeConfiguration(id:any) {
        return this.http.get(`${this.backendUrl}${this.api}all-coupon-data/${id}/` , this.jwt_new()).map((response: Response) => response.json());
    }

    getallPromotionTypeByFbAdd(id:any) {
        return this.http.get(`${this.backendUrl}${this.api}all-promotion-data-fbadd/${id}/` , this.jwt_new()).map((response: Response) => response.json());
    }

    getallCouponSettingsTag(id:any) {
        return this.http.get(`${this.backendUrl}${this.api}all-cpsettings-data/${id}/` , this.jwt_new()).map((response: Response) => response.json());
    }

    GenerateCouponCode(data) {
        return this.http.post(`${this.backendUrl}${this.api}add-generate-coupon/` , data, this.jwt_new()).map((response: Response) => response.json());
    }

    GenerateCouponLogs(data) {
        return this.http.post(`${this.backendUrl}${this.api}add-generatelogs-coupon/` , data, this.jwt_new()).map((response: Response) => response.json());
    }

     getallDownloadCSVData(code:any,id:any) {
        return this.http.get(`${this.backendUrl}${this.api}all-CSV-data/${code}/${id}/` , this.jwt_new()).map((response: Response) => response.json());
    }

     getViewGeneratedCouponData(id:any) {
        return this.http.get(`${this.backendUrl}${this.api}view-generated-coupon/${id}/` , this.jwt_new()).map((response: Response) => response.json());
    }

    AddNewCouponSettings(data) {
        return this.http.post(`${this.backendUrl}${this.api}add-coupon-settings/` , data, this.jwt_new()).map((response: Response) => response.json());
    }

    getCouponClaimedCountReport(rest_id:any,code:any) {
        return this.http.get(`${this.backendUrl}${this.api}coupon-claimed-count/${rest_id}/${code}/` , this.jwt_new()).map((response: Response) => response.json());
    }

    getCouponUniqueTotalClaimed(rest_id:any,code:any) {
        return this.http.get(`${this.backendUrl}${this.api}unique-total-claimed-count/${rest_id}/${code}/` , this.jwt_new()).map((response: Response) => response.json());
    }

    private jwt_new() {
        this.TOKEN = (localStorage.getItem('id_token') != undefined) ? localStorage.getItem('id_token') : localStorage.getItem('login_token');
        this.headers = new Headers({ 'Content-Type': 'application/json' });
        this.headers.append('Authorization', this.TOKEN)
        this.options = new RequestOptions({ headers: this.headers });
        return this.options;
    }

    private jwt() {
        // create authorization header with jwt token
        this.TOKEN = (localStorage.getItem('id_token') != undefined) ? localStorage.getItem('id_token') : localStorage.getItem('login_token');
        let headers = new Headers({ 'Authorization': this.TOKEN });
        return new RequestOptions({ headers: headers });
    }
}


// WEBPACK FOOTER //
// /var/www/html/foodbot_stage/web/src/app/_services/generatecp.service.ts